import React from 'react';
import {
  Create,
  TabbedForm,
  FormTab,
  SelectInput,
  FormDataConsumer,
} from 'react-admin';
import BankLinkConfig from './BankLinkConfig';
import { ConfigTypeEnum } from '../../helpers/mappings';
import BankTransferConfig from './BankTransferConfig';

export default props => (
  <Create
    {...props}
    title="Create Config"
  >
    <TabbedForm redirect="show">
      <FormTab label="Configuration">
        <SelectInput
          label="Configuration Type"
          source="configType"
          choices={ConfigTypeEnum}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => formData.configType === 'bank_link' && <BankLinkConfig {...rest} />}
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData, ...rest }) => formData.configType === 'bank_transfer' && <BankTransferConfig {...rest} />}
        </FormDataConsumer>
      </FormTab>
    </TabbedForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/Config/Create.jsx